var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"base-preloader"},[_c('img',{staticClass:"logo-preloader",attrs:{"src":require("@/assets/img/logo-no-text.svg"),"alt":"Loading..."}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }